import React, { useState } from 'react';
import CustomSelectDropdown from '../DropDown/CustomSelectDropdown';

const formatCreditsDisplay = (value) => {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) {
    return '—';
  }
  return Number(value).toLocaleString('fr-FR');
};

export const DetailsIaTraduction = ({
  t,
  expanded,
  setExpanded,
  formData,
  errors,
  isFieldDisabled,
  handleChange,
  handleBlur,
  translationAgents = [],
  loadingAgents = false,
  history,
  onCreateCustomAgent,
  onAgentChange,
  onNavigateToAgentEdit,
  onStartTranslation,
  isTranslating = false,
  hasTranslatedContent = false,
  isCreditsExhausted = false,
  onCreditsLimitClick = () => { },
  onOpenTranslationSettings = () => { },
  remainingCredits = null,
}) => {
  const { keyword, url, titleTag, metaDescriptionTag, agentIA } = formData || {};
  const { titleError, metaDescriptionError, agentError, keywordError } = errors || {};

  const [showSeoTags, setShowSeoTags] = useState(false);
  const [showUrlSection, setShowUrlSection] = useState(false);
  const [showAgentSection, setShowAgentSection] = useState(false);
  const selectedAgent =
    (translationAgents || []).find((agent) => agent.id === agentIA) || null;
  const [isEditingKeyword, setIsEditingKeyword] = useState(false);
  const [keywordDraft, setKeywordDraft] = useState(keyword || '');

  const startKeywordEdit = () => {
    if (isFieldDisabled('keyword')) return;
    setKeywordDraft(keyword || '');
    setIsEditingKeyword(true);
  };

  const confirmKeywordEdit = () => {
    if (isFieldDisabled('keyword')) {
      setIsEditingKeyword(false);
      return;
    }

    if (typeof handleChange === 'function') {
      const onChange = handleChange('keyword');
      if (typeof onChange === 'function') {
        onChange({ target: { value: keywordDraft || '' } });
      }
    }

    setIsEditingKeyword(false);
  };

  return (
    <>
      <style>{`
        .textdetails-display {
          max-width: 2500px;
        }
        .textdetails-title {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-size: 20px;
          font-weight: 600;
          color: #000;
          margin-bottom: 4px;
          margin-left: 20px;
        }
        .textdetails-title-text {
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }
        .textdetails-title-edit-icon {
          font-size: 13px;
          color: #9CA3AF;
          opacity: 0;
          transition: opacity 0.2s;
        }
        .textdetails-title:hover .textdetails-title-edit-icon {
          opacity: 1;
        }
        .textdetails-badge {
          display: inline-flex;
          align-items: center;
          background-color: #e8d4ff;
          color: #7c3aed;
          padding: 4px 12px;
          border-radius: 16px;
          font-size: 13px;
          font-weight: 500;
          margin-left: 10px;
        }
        .textdetails-info {
          color: #666;
          font-size: 14px;
          margin-bottom: 15px;
          line-height: 1.6;
          margin-left: 20px;
          display: flex;
          align-items: center;
          gap: 16px;
          flex-wrap: wrap;
        }
        .textdetails-buttons {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-left: 20px;
          gap: 10px;
          margin-bottom: 10px;
        }
        .textdetails-buttons-left {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }
        .textdetails-buttons-right {
          margin-left: auto;
          display: inline-flex;
          align-items: center;
          gap: 10px;
        }
        .textdetails-btn {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 14px;
          background-color: #F1F1F1;
          border: 1px solid #EEEEEE;
          border-radius: 999px;
          font-size: 13px;
          color: #333;
          cursor: pointer;
          transition: all 0.2s;
          box-shadow: 0 1px 3px rgba(228, 227, 227, 0.85);
        }
        .textdetails-btn svg {
          width: 14px;
          height: 14px;
        }
        .textdetails-btn:hover {
          background-color: #EEF2FF;
          border-color: #C7D2FE;
        }
        .textdetails-modal {
          margin-top: 15px;
          margin-left: 20px;
          margin-right: 20px;
          padding: 0;
          background-color: transparent;
          border: none;
          box-shadow: none;
          margin-bottom: 10px;
        }
        .textdetails-field {
          margin-bottom: 18px;
          padding: 16px 18px;
          background: #FAFAFA;
          border-radius: 8px;
          border: 1px solid #E9E9E9;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
        }
        .textdetails-field.textdetails-field-agent {
          margin-bottom: 10px;
          padding: 8px 10px;
          width:30%; 
          margin-left: 1300px;
        }
        .textdetails-field label {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-weight: 600;
          font-size: 14px;
          color: #333;
          margin-bottom: 8px;
          gap: 8px;
        }
        .textdetails-field input {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
          color: #333;
          transition: border-color 0.2s;
          background-color: white;
        }
        .textdetails-field input:focus {
          outline: none;
          border-color: #7c3aed;
        }
        .textdetails-title-edit {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-left: 20px;
          margin-bottom: 4px;
        }
        .textdetails-title-input {
          padding: 8px 10px;
          border-radius: 6px;
          border: 1px solid #D1D5DB;
          font-size: 14px;
          min-width: 400px;
        }
        .textdetails-title-input:focus {
          outline: none;
          border-color: #7c3aed;
        }
        .textdetails-title-check {
          border: none;
          background-color: transparent;
          color: #111827;
          border-radius: 0;
          padding: 0 4px;
          font-size: 16px;
          cursor: pointer;
        }
        .textdetails-credits-badge {
          display: inline-flex;
          align-items: center;
          gap: 2px;
          padding: 4px 11px;
          border-radius: 999px;
          background-color: rgb(183, 238, 212);
          border: 1px solid #bbf7d0;
          flex-shrink: 0;
        }
        .textdetails-credits-badge-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          line-height: 0;
          color: #ca8a04;
        }
        .textdetails-credits-badge-icon svg {
          display: block;
          width: 18px;
          height: 18px;
        }
        .textdetails-credits-badge-text {
          font-size: 12px;
          font-weight: 600;
          color: #166534;
          white-space: nowrap;
        }
        .textdetails-relancer {
          border: none;
          background-color: transparent;
          color: #5E45E6;
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          cursor: pointer;
        }
        .textdetails-actions-separator {
          width: 1px;
          height: 18px;
          background-color: #E5E7EB;
          margin-top: 5px;
        }
        .textdetails-params {
          border: none;
          background-color: transparent;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: #111827;
          font-weight: 500;
          cursor: pointer;
        }
        .textdetails-params-icon {
          width: 16px;
          height: 16px;
        }
        .textdetails-agent-mini {
          font-size: 12px;
          padding: 2px 8px;
          border-radius: 10px;
          background-color: #F3F4F6;
          color: #4B5563;
   
        } 
        /* <= 1335px */
        @media (max-width: 1336px) {
          .textdetails-field.textdetails-field-agent {
            margin-left: 850px;
          }
        }

        /* 1336px -> 1535px */
        @media (min-width: 1337px) and (max-width: 1539px) {
          .textdetails-field.textdetails-field-agent {
            margin-left:1030px;
          }
        }
      `}</style>

      <div className="row">
        <div className="col-12">
          <div className="box-wrapper-editor textdetails-display">
            {isEditingKeyword ? (
              <div style={{ marginBottom: '15px', marginTop: 20 }}>
                <div className="textdetails-title-edit">
                  <input
                    type="text"
                    className="textdetails-title-input"
                    value={keywordDraft}
                    onChange={(e) => setKeywordDraft(e.target.value)}
                    placeholder={t('Mot clé')}
                    disabled={isFieldDisabled('keyword')}
                  />
                  <button
                    type="button"
                    className="textdetails-title-check"
                    onClick={confirmKeywordEdit}
                    disabled={isFieldDisabled('keyword')}
                    title={t('Valider le mot clé')}
                  >
                    ✓
                  </button>
                  <span className="textdetails-badge">
                    <img
                      src="/Images/gen-icon-ai.png"
                      alt="AI"
                      style={{ width: 16, height: 16, marginRight: 6 }}
                    />
                    {t('Généré par IA')}
                  </span>
                </div>
                {keywordError && (
                  <div className="invalid-feedback d-block" style={{ marginLeft: 20, marginTop: 4 }}>
                    {t('Ce champ est obligatoire')}
                  </div>
                )}
              </div>
            ) : (
              <div style={{ marginBottom: '15px', marginTop: 20 }}>
                <span
                  className="textdetails-title"
                  onClick={!isFieldDisabled('keyword') ? startKeywordEdit : undefined}
                  title={t('Modifier le mot clé')}
                >
                  <span className="textdetails-title-text">
                    {keyword || t('Détails du texte')}
                  </span>
                  {!isFieldDisabled('keyword') && (
                    <span className="textdetails-title-edit-icon">✎</span>
                  )}
                </span>
                <span className="textdetails-badge">
                  <img
                    src="/Images/gen-icon-ai.png"
                    alt="AI"
                    style={{ width: 16, height: 16, marginRight: 6 }}
                  />
                  {t('Généré par IA')}
                </span>
              </div>
            )}

            <div className="textdetails-info">
              <span>
                {t('Mot clé')} : {keyword || t('Non défini')}
              </span>
              {url && (
                <span>
                  {t('URL')} : {url}
                </span>
              )}
              {selectedAgent && (
                <span className="textdetails-agent-mini">
                  {t('Agent IA')} : {selectedAgent.displayName || selectedAgent.name || `#${selectedAgent.id}`}
                </span>
              )}
            </div>

            <div className="textdetails-buttons">
              <div className="textdetails-buttons-left">
                <button
                  type="button"
                  className="textdetails-btn"
                  onClick={() => setShowSeoTags(!showSeoTags)}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                  {t('Balise Title & Meta')}
                </button>

                <button
                  type="button"
                  className="textdetails-btn"
                  onClick={() => setShowUrlSection(!showUrlSection)}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                  {t('URL')}
                </button>
              </div>

              {onStartTranslation && (
                <div className="textdetails-buttons-right">
                  {remainingCredits !== null && (
                    <>
                      <div className="textdetails-credits-badge" aria-label={t('Crédits IA')}>
                        <span className="textdetails-credits-badge-icon" aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" />
                          </svg>
                        </span>
                        <span className="textdetails-credits-badge-text">
                          {formatCreditsDisplay(remainingCredits)} {t('Crédits IA')}
                        </span>
                      </div>
                      <span className="textdetails-actions-separator" />
                    </>
                  )}
                  <button
                    type="button"
                    className="textdetails-relancer"
                    onClick={isCreditsExhausted ? onCreditsLimitClick : onStartTranslation}
                    disabled={isTranslating}
                  >
                    {isTranslating ? (
                      t('Traduction en cours...')
                    ) : (
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                        <img
                          src="/images/icon-relan-ia.png"
                          alt="Relancer IA"
                          style={{ width: 16, height: 16 }}
                        />
                        {hasTranslatedContent ? t('Relancer la traduction') : t('Traduire')}
                      </span>
                    )}
                  </button>
                  <span className="textdetails-actions-separator" />
                  <button
                    type="button"
                    className="textdetails-params"
                    onClick={() => {
                      if (isCreditsExhausted) {
                        onCreditsLimitClick();
                        return;
                      }
                      setShowAgentSection((prev) => !prev);
                      if (onOpenTranslationSettings) {
                        onOpenTranslationSettings();
                      }
                    }}
                  >
                    <img
                      src="/Images/set-icon.png"
                      alt={t('Paramètres de traduction')}
                      className="textdetails-params-icon"
                    />
                    {t('Paramètres de traduction')}
                  </button>
                </div>
              )}
            </div>

            <div className="textdetails-modal">
              {showAgentSection && (
                <div className="textdetails-field textdetails-field-agent">
                  <label>
                    {t('Agent IA')}*
                  </label>
                  <div style={{ width: '100%' }}>
                    <CustomSelectDropdown
                      options={translationAgents || []}
                      value={translationAgents.find(agent => agent.id === agentIA) || null}
                      onChange={(agent) => {
                        if (onAgentChange) {
                          onAgentChange(agent);
                        } else {
                          if (agent && handleChange('agentIA')) {
                            handleChange('agentIA')({ target: { value: agent.id } });
                          } else if (!agent && handleChange('agentIA')) {
                            handleChange('agentIA')({ target: { value: '' } });
                          }
                        }
                      }}
                      getOptionLabel={(option) =>
                        option?.displayName || option?.name || ''
                      }
                      renderOptionLabel={(option, isSelectedDisplay) => {
                        if (!option) return null;
                        const name = option.displayName || option.name || '';
                        const lang =
                          option.language ||
                          option.langue ||
                          option.lang ||
                          option.code ||
                          '';

                        if (isSelectedDisplay) {

                          return (
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <span>{name}</span>
                              {lang && (
                                <span
                                  style={{
                                    color: '#4B5563',
                                    fontSize: 12,
                                    marginLeft: 'auto',
                                  }}
                                >
                                  {lang}
                                </span>
                              )}
                            </span>
                          );
                        }

                        if (lang) {
                          return (
                            <span>
                              {name} - <span style={{ color: '#4B5563' }}>{lang}</span>
                            </span>
                          );
                        }

                        return <span>{name}</span>;
                      }}
                      getOptionValue={(option) => option?.id}
                      placeholder={loadingAgents ? t('Chargement...') : t('Sélectionner un agent IA')}
                      disabled={isFieldDisabled('agentIA')}
                    />
                  </div>
                  {agentError && (
                    <div className="invalid-feedback d-block">
                      {t('Ce champ est obligatoire')}
                    </div>
                  )}
                </div>
              )}

              {showSeoTags && (
                <>
                  <div className="textdetails-field">
                    <label htmlFor="titleTagInput">
                      {t('Balise titre')}
                    </label>
                    <input
                      id="titleTagInput"
                      name="titleTag"
                      type="text"
                      className={titleError ? 'is-invalid' : ''}
                      placeholder={t('Balise titre')}
                      value={titleTag}
                      onChange={!isFieldDisabled('titleTag') ? handleChange('titleTag') : undefined}
                      onBlur={handleBlur('titleTag')}
                      disabled={isFieldDisabled('titleTag')}
                    />
                    {titleError && (
                      <div className="invalid-feedback d-block">
                        {t('Ce champ est obligatoire')}
                      </div>
                    )}
                  </div>

                  <div className="textdetails-field">
                    <label htmlFor="metaDescriptionInput">
                      {t('Balise meta-description')}
                    </label>
                    <input
                      id="metaDescriptionInput"
                      name="metaDescriptionTag"
                      type="text"
                      className={metaDescriptionError ? 'is-invalid' : ''}
                      placeholder={t('Balise meta-description')}
                      value={metaDescriptionTag}
                      onChange={!isFieldDisabled('metaDescriptionTag') ? handleChange('metaDescriptionTag') : undefined}
                      onBlur={handleBlur('metaDescriptionTag')}
                      disabled={isFieldDisabled('metaDescriptionTag')}
                    />
                    {metaDescriptionError && (
                      <div className="invalid-feedback d-block">
                        {t('Ce champ est obligatoire')}
                      </div>
                    )}
                  </div>
                </>
              )}

              {showUrlSection && (
                <div className="textdetails-field">
                  <label htmlFor="urlInput">
                    {t('URL')}
                  </label>
                  <input
                    id="urlInput"
                    name="url"
                    type="text"
                    placeholder="https://www."
                    value={url}
                    onChange={!isFieldDisabled('url') ? handleChange('url') : undefined}
                    disabled={isFieldDisabled('url')}
                  />
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailsIaTraduction;


